import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { EnvironmentConfigService, isNotNullOrUndefined, SettingsService } from '@stylehaven/components';
import { AuthenticationSandbox } from '../sandbox/authentication.sandbox';

@Injectable({ providedIn: 'root' })
export abstract class HostNameGuard {
    protected abstract app: string;

    constructor(
        protected configService: EnvironmentConfigService,
        protected settingsService: SettingsService,
        protected authSandbox: AuthenticationSandbox
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const redirectStream$: Observable<boolean> = this.settingsService.get('public_host').pipe(
            isNotNullOrUndefined(),
            switchMap(hostName =>
                hostName.Value !== window.location.hostname
                    ? this.getRedirectStream(hostName.Value as string)
                    : of(true)
            )
        );

        return this.configService
            .get('publicHostRedirect')
            .pipe(switchMap(skipLogin => (skipLogin ? redirectStream$ : of(true))));
    }

    private getRedirectStream(hostname: string): Observable<boolean> {
        const redirectUri = `https://${hostname}/${this.app}`;
        return this.authSandbox.getOauthLogoutUrlWithRedirectStream(redirectUri).pipe(
            take(1),
            map(oauthUrl => {
                this.authSandbox.logout();

                window.location.href = oauthUrl;
                return false;
            })
        );
    }
}
